import AuthenticatedRoute from 'eflex/util/authenticated-route';
import { service } from '@ember/service';

export default class BomManagerIndexRoute extends AuthenticatedRoute {
  @service bomSourceRepo;
  @service router;

  afterModel() {
    const bomSource = this.bomSourceRepo.allBomSources[0];
    if (bomSource != null) {
      this.router.transitionTo('bomManager.bomSource', bomSource.id);
    }
  }
}
